<div class="user-info-panel" style="padding-top: 0">
  <div class="card">
    <div class="flex">
      <div class="flex-grow-1 flex align-items-center">
        <h2 class="font-semibold flex align-items-center gap-2">
          <mat-icon class="hover-pointer" (click)="toggleExpand()">{{
            detailsExpanded ? 'expand_more' : 'chevron_right'
          }}</mat-icon>
          @if (detailLink?.length) {
            <a
              class="header-name-link"
              [routerLink]="detailLink"
              [queryParams]="detailQueryParams ?? {}"
              target="_blank"
              >{{ data?.provider }}</a
            >
          } @else {
            <span>{{ data?.provider }}</span>
          }
        </h2>
        <span class="sub-header">{{ data?.type }}</span>
      </div>
      <div class="flex-none pr-3 pt-1">
        <div class="flex flex-row justify-content-end">
          <div [class]="'flex flex-row align-items-center status-badge py-2 px-3 ' + getStatusBadgeClass(data?.status)">
            <span class="medium-small-text">{{ data?.status }}</span>
          </div>
          @if (data?.verified) {
            <div class="flex flex-row align-items-center status-badge py-2 px-3 ml-4 verified">
              <lib-svg-icon
                class="mr-1"
                [svgName]="blueCheckIcon"
                [svgHeight]="'17px'"
                [svgWidth]="'16px'"></lib-svg-icon>
              <span class="medium-small-text">Verified</span>
            </div>
          }
        </div>
      </div>
      <div class="flex-none">
        @if (detailsExpanded) {
          @if (editing) {
            <span [matTooltip]="isArchived ? 'Closed message details cannot be edited.' : ''">
              <button
                (click)="toggleSave()"
                mat-flat-button
                class="edit-button status-badge mt-2"
                [disabled]="isArchived">
                <div class="flex flex-row align-items-center">
                  <lib-svg-icon
                    class="mr-1"
                    [svgName]="editIcon"
                    [svgHeight]="'16px'"
                    [svgWidth]="'15px'"></lib-svg-icon>
                  <span class="thin-text default-text">Save</span>
                </div>
              </button>
            </span>
          } @else {
            <span [matTooltip]="isArchived ? 'Closed message details cannot be edited.' : ''">
              <button
                (click)="toggleEdit()"
                mat-flat-button
                class="edit-button status-badge mt-2"
                [disabled]="isArchived">
                <div class="flex flex-row align-items-center">
                  <lib-svg-icon
                    class="mr-1"
                    [svgName]="editIcon"
                    [svgHeight]="'16px'"
                    [svgWidth]="'15px'"></lib-svg-icon>
                  <span class="thin-text default-text">Edit</span>
                </div>
              </button>
            </span>
          }
        }
      </div>
    </div>
  </div>
</div>
